import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import {
    faCaretRight,
    faFilePdf,
    faMapMarkerAlt,
    faEnvelope,
    faPhone,
    faMoneyCheck,
} from '@fortawesome/free-solid-svg-icons';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';
import { DialogConfirmActionComponent } from 'src/app/@theme/components';
import TournamentBase from '../../tournament-base';
import { NgxGlideComponent } from 'ngx-glide';
import { UserService } from 'src/app/modules/user/user.service';
import { GetTournamentByIdResponse, GetTournamentPointsResponse } from '../../tournament.interface';
import { LocalStorage } from '@core/localstorage';

@Component({
    selector: 'app-shared-tournament-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
})
export class TournamentHomeComponent extends TournamentBase implements OnInit {
    departmentType: string = this.getDepartmentType();
    tournamentId: string = this.route.snapshot.paramMap.get('tournamentId');

    tournament: GetTournamentByIdResponse;

    shouldLogin: boolean;
    hasSubscription: boolean;
    disableSubscription: boolean;
    subscribedInCategory: any;

    pointsSelectedCategory: string;
    points: GetTournamentPointsResponse;

    icons = {
        caretRight: faCaretRight,
        pdf: faFilePdf,
        marker: faMapMarkerAlt,
        email: faEnvelope,
        phone: faPhone,
        money: faMoneyCheck,
    };

    collapse = {
        inscricoes: false,
        locais: false,
        departamento: false,
        categorias: false,
        anexos: false,
        infos: false,
        regulation: true,
        hoteis: false,
        program: false,
        pontuacao: false,
    };
    loading: boolean = false;
    loadingPoints: boolean = false;
    /**
     * Instancia do ngx glide
     */
    @ViewChildren('ngxGlide') ngxGlide!: QueryList<NgxGlideComponent>;

    /**
     * Configuração do slide por breakpoint
     */
    breakpoints = {
        767: {
            perView: 1,
        },
    };

    currentUser$;

    constructor(
        protected route: ActivatedRoute,
        private toastr: NbToastrService,
        private dialog: NbDialogService,
        private translate: TranslateService,
        private user: UserService,
        private localStorage: LocalStorage
    ) {
        super();
    }

    ngOnInit() {
        this.getTournament();
        this.currentUser$ = this.user.currentUser;
    }

    onTabChange($event) {
        setTimeout(() => {
            this.ngxGlide.forEach((ngxGlide) => ngxGlide.recreate());
        }, 0);
    }

    getTournament() {
        this.loading = true;
        this.tournamentService.getTournamentByID(this.tournamentId, this.departmentType).subscribe(
            (successResponse) => {
                this.tournament = successResponse.registers;
                this.pointsSelectedCategory = this.tournament.points?.categoria_ativa;
                this.points = this.tournament.points;
                this.loading = false;
                this.getParamsFromCategory();
            },
            (errorResponse) => {
                this.loading = false;
            }
        );
    }

    /**
     * Procura parametros de login, cancelamento de inscrição, e pagamento
     * que se encontram dentro da categoria no retorno da API
     */
    getParamsFromCategory() {
        this.shouldLogin = this.tournament.category.some((category) => category.set_login);

        const subscribedIncategory = this.tournament.category.find((category) => category.inscricao);
        if (subscribedIncategory) {
            this.hasSubscription = true;
            this.subscribedInCategory = subscribedIncategory;
        }
    }

    get backRoute() {
        const urlArr = this.router.url.split('/');
        urlArr.pop();
        return urlArr.join('/');
    }

    get tournamentStatusColor() {
        switch (this.tournament.detail.situacao) {
            case '3':
                return 'success';
            case '5':
                return 'info';
            case '9':
                return 'danger';
            default:
                return 'basic';
        }
    }

    isCbt(): boolean {
        return (
            this.localStorage.getHost().includes('cbt.tenisintegrado.com.br') ||
            this.localStorage.getHost().includes('cbt.esp.br') ||
            this.localStorage.getHost().includes('cbt-tenis.com.br') ||
            this.localStorage.getHost().includes('cbtenis.com.br')
        );
    }

    getTotalQuadras(local) {
        return (
            Number(local.qtd_quadras_jogo_1 ?? 0) +
            Number(local.qtd_quadras_jogo_2 ?? 0) +
            Number(local.qtd_quadras_jogo_3 ?? 0)
        );
    }

    getPisos(local) {
        let piso = local.tipo_piso_1;
        if (local.tipo_piso_2) {
            piso += `, ${local.tipo_piso_2}`;
        }
        if (local.tipo_piso_3) {
            piso += `, ${local.tipo_piso_3}`;
        }
        return piso;
    }

    isHtmlContentEmpty(htmlContent: string): boolean {
        if (!htmlContent) return true;

        // Create temporary element to parse the HTML
        const tempElement = document.createElement('div');
        tempElement.innerHTML = htmlContent;

        // Get the text content without HTML tags
        const textContent = tempElement.textContent || tempElement.innerText || '';

        // Check if there's any non-whitespace content
        return textContent.trim() === '';
    }

    onPointsCategoryChange(categoryId: string) {
        this.loadingPoints = true;
        this.tournamentService.getTournamentPoints(this.tournamentId, categoryId).subscribe(
            (response) => {
                this.points = response.registers;
                this.loadingPoints = false;
            },
            (error) => {
                this.loadingPoints = false;
            }
        );
    }
}
